"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaidVia = exports.EventTypes = void 0;
var EventTypes;
(function (EventTypes) {
    EventTypes["DINNER_TICKET"] = "dinner-ticket";
    EventTypes["EXPERIENCE"] = "experience";
    EventTypes["MINIMUM_CONSUMPTION"] = "minimum-consumption";
    EventTypes["PRE_ORDER"] = "pre-order";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
var PaidVia;
(function (PaidVia) {
    PaidVia["STRIPE"] = "stripe";
    PaidVia["MOLLIE"] = "mollie";
    PaidVia["CASH"] = "cash";
})(PaidVia = exports.PaidVia || (exports.PaidVia = {}));
